import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import "@polymer/paper-icon-button/paper-icon-button.js";
import "@polymer/iron-icons/iron-icons.js";
import "@polymer/paper-dialog/paper-dialog.js";
import "@polymer/paper-checkbox/paper-checkbox.js";
import "@polymer/paper-card/paper-card.js";
import "@polymer/paper-tooltip/paper-tooltip.js";
import "@vaadin/polymer-legacy-adapter/template-renderer.js";
import "@vaadin/vaadin-grid/vaadin-grid.js";
import "@vaadin/vaadin-grid/theme/material/vaadin-grid-selection-column.js";
import { autorun } from "mobx";
async function asyncPool(poolLimit, array, iteratorFn) {
    // source https://github.com/rxaviers/async-pool/blob/master/lib/es7.js
    const ret = [];
    const executing = [];
    for (const item of array) {
        const p = Promise.resolve().then(() => iteratorFn(item, array));
        ret.push(p);
        if (poolLimit <= array.length) {
            const e = p.then(() => executing.splice(executing.indexOf(e), 1));
            executing.push(e);
            if (executing.length >= poolLimit) {
                // eslint-disable-next-line no-await-in-loop
                await Promise.race(executing);
            }
        }
    }
    return Promise.all(ret);
}
class SiteDocumentManagement extends PolymerElement {
    static get is() {
        return "site-document-management";
    }
    static get template() {
        return html `
        <style include="shared-styles">
          #add-files {
            display: flex;
            justify-content: flex-end;
          }

          #add-files-btn[disabled] {
            opacity: 0.5;
          }

          paper-card {
            height: 100%;
            width: 95%;
            padding: 30px;
            margin: 20px;
            flex-direction: column;
            justify-content: center;  
          }


          #addFilesDialog{
            width: 500px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .download-button {
            background-color:var(--paper-green-500);
            color: white;
          }

           .download-button:hover {
              background-color:var(--paper-green-200);

           }



          .delete-button {
            /* border: 1px solid var(--paper-red-500); */
            color: var(--paper-red-500);
          }


          .delete-button:hover {
            /* border: 1px solid var(--paper-red-500); */
            color: white;
            background-color: var(--paper-red-500);
          }

          #info-text {
            /* border-style: solid; */
            /* border-color: blue; */
            display: inline;
            display: flex;
            justify-content: center;
          }

          #info-text iron-icon {
              margin-top: 12px;
              padding-right: 5px;
          }

          #info-banner {
              /* border-style: solid; */
              /* border-color: red; */
              padding-top: 15px;
              display: flex;
              justify-content: space-between;
          }

          .file-upload-container {
            padding-bottom: 10px;
          }

          paper-button.green {
                    background-color:var(--paper-green-500);
                    color: white;
                    --paper-button-raised-keyboard-focus: {
                        background-color: var(--paper-pink-a200) !important;
                        color: white !important;
                    }
                }

          paper-button.green[disabled] {
              background-color: white;
              color: var(--paper-grey-500);
          }

         #dropZone {
          width:  90%;
          height: 220px;
          border: dashed;
          border-color: #757575;
          /* padding: 20px; */
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: center;
          align-items: center;
          margin-left: auto;
          margin-right: auto;
          margin-top: 10px;
          margin-top: 10px;
          font-size: 18px;
          --iron-icon-height: 80px;
          --iron-icon-width: 80px;

        }

        #upload-buttons {
          float: right;

        }

        #dropZone p {
          margin-bottom: 5px;
        }

        #submitSpinner {
          --paper-spinner-stroke-width: 5px;
          position: absolute;
          top: 40%;
          left: 47%;
          z-index: 9999;
        }

        #document-interaction {
          float:right;
          width: 200px;
        }

        #delete-confirmation {
          height: 200px;
          width: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          /* text-align: center; */
        }

        #delete-confirmation h1 {
          /* font-size: 20px; */
          margin-bottom: 0px;
        }


        .confirm-delete-button {
          color: white;
            background-color: var(--paper-red-500);
        }

        .confirm-delete-button:hover {
          color: white;
            background-color: var(--paper-red-300);
        }


        paper-tooltip#add-files-tip {
            /* --paper-tooltip-background: black; */
            --paper-tooltip: {
                font-size: 15px;
                
        }
    }



        </style>

    
      <div class="card">
        <h1>[[jobId]]</h1>
        <div id="add-files">
            <div id="upload-documents-button">
                <paper-button id="add-files-btn" on-click="addDocuments">
                <iron-icon icon="icons:add"></iron-icon>  
                Add Documents
                </paper-button>
                <paper-tooltip id="add-files-tip" for="upload-documents-button" offset="-10" position="top" animation-delay="0">[[_computeTooltipMessage(permissions)]]</paper-tooltip>
            </div>
        </div>
        <div id="files">

        <vaadin-grid
            id="filesGrid"
            area-label="site files"
            items="{{files}}"
            class="file_table"
        >

            <vaadin-grid-column resizable="true" >
                <template class="header">
                      Name
                </template>
                <template
                    >[[item.title]]</template
                >
            </vaadin-grid-column>

            <vaadin-grid-column width="100px" flex-grow="0">
                <template class="header">
                Size
                </template>
                <template
                    >[[_getFileSize(item.size)]]</template
                >
            </vaadin-grid-column>

            <vaadin-grid-column  resizable="true">
                <template class="header">
                Upload Time
                </template>
                <template
                    >[[getLocalDateTime(item.uploadDate)]]</template
                >
            </vaadin-grid-column>

            <vaadin-grid-column  auto-width>
                <template>
                  <div id="document-interaction">
                  <template is="dom-if" if="{{canDelete(item.type)}}">
                          <paper-button id="[[item.id]]" on-click="openDeleteConfirmation" class="delete-button">Delete</paper-button>
                  </template>
                  <paper-button id="[[item.title]]" on-click="downloadDocument" class="download-button">Open</paper-button>
                  </div>
                </template>
            </vaadin-grid-column>
        </vaadin-grid>
        <p>[[files.length]] Documents</p>

        </div>
            <paper-dialog id="addFilesDialog">
              <paper-card>
                  <h2>Upload Documents</h2>
                  <div class="file-upload-container">
                    <input text="select files" type="file" id="fileInput" on-change="changeFiles" multiple="">
                  </div>

                  <div id="dropZone" on-drop="dropHandler" on-dragover="dragOverHandler">
                    <p>Drag one or more files</p>
                    <iron-icon style="color: #757575" icon="icons:backup"></iron-icon>
        

                  </div>
                  
                 
                
                <!-- Issue Message -->
                        <div id="info-text">
                            <iron-icon style="font-size:140px; display: inline-block; --iron-icon-fill-color: [[_computeUploadIconColour(uploadStatus)]]" icon="custom-icons:[[_computeUploadIcon(uploadStatus)]]"></iron-icon>
                            <p >[[_computeUploadMessage(uploadStatus)]]</p>
                        </div>

                        <!--Submit-->
                        <div id="upload-buttons">
                            <paper-button
                            id="upload-button"
                            raised=""
                            on-click="upload"
                            class="green"
                            disabled="[[_computeDisabledUpload(uploadStatus)]]"
                            >
                            Upload [[filesToUpload.length]] files
                          </paper-button>
                          
                          <paper-button
                          id="cancel"
                          raised=""
                          on-click="close"
                          class="red"
                          disabled="[[uploading]]"

                          >
                          Close
                        </paper-button>
                    </div>

                    <paper-spinner-lite
                                id="submitSpinner"
                                hidden=""
                            ></paper-spinner-lite>
            </paper-card>

            </paper-dialog>

            <paper-dialog id="delete-confirmation">
                <h1>DELETE</h1>
                <p>Are you sure you want to delete <strong>[[deleteTitle]]</strong> </p>
                <div id="delete-options">
                  <paper-button on-click="deleteDocument" class="confirm-delete-button">Delete</paper-button>
                  <paper-button on-click="closeDeleteConfirmation" class="cancel-button">Cancel</paper-button>
                </div>
            </paper-dialog>
        </div>
        </div>

        <api-request
                id="apiRequest"
                url="[[url]]"
                authorization-required="[[authorizationRequired]]"
            >
            </api-request>
      </div>
      
      `;
    }
    static get properties() {
        return {
            jobId: { type: String, observer: "_jobChange" },
            url: { type: String },
            apiBaseUrl: { type: String },
            files: { type: Array, value: [] },
            filesToUpload: { type: Array, value: [] },
            uploadStatus: {
                type: String,
                computed: "_computeUploadStatus(filesToUpload, uploading)",
            },
            uploading: {
                type: Boolean,
                value: false,
                observer: "_uploadingChange",
            },
            resourceToken: {
                type: String,
                notify: true,
                observer: "resourceTokenChange",
            },
            resourceTokenInfo: {
                type: Object,
                notify: true,
            },
            permissions: {
                type: Object,
                observer: "_permissionsChange",
            },
            deleteId: {
                type: String,
            },
            deleteTitle: {
                type: String,
                computed: "_getDeleteFilename(deleteId)",
            },
            store: {
                type: Object,
            },
        };
    }
    ready() {
        super.ready();
    }
    async _jobChange(newJob) {
        if (!newJob) {
            return;
        }
        this.resource = `/jobs/${this.jobId}`;
        // NOTE: not sure if we need to do this every time a job id is changed,
        // are we going to have a lot of auto runs ??
        autorun(async () => {
            if (!this.store.app.activeGroup) {
                return;
            }
            await this.updateUserPermissions();
            await this.setDocuments();
        });
    }
    // eslint-disable-next-line class-methods-use-this
    getLocalDateTime(uploadTime) {
        if (!uploadTime) {
            return "";
        }
        const options = {
            weekday: "long",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        };
        return new Date(uploadTime).toLocaleTimeString("en-au", options);
    }
    _permissionsChange(permissions) {
        if (!permissions.write) {
            this.$["add-files-btn"].disabled = true;
        }
        if (permissions.write) {
            this.$["add-files-btn"].disabled = false;
        }
    }
    _computeTooltipMessage() {
        return this.permissions.write
            ? "Upload documents"
            : "You do not have permissions to upload documents";
    }
    // eslint-disable-next-line class-methods-use-this
    _getFileSize(size) {
        if (!size) {
            return "";
        }
        return `${size}mb`;
    }
    _getDeleteFilename(deleteId) {
        if (!deleteId)
            return "";
        const { title } = this.files.find((f) => f.id === deleteId);
        return title;
    }
    async updateUserPermissions() {
        console.debug(`${this.constructor.is}: Updating user permissions`);
        const { scope } = await this.store.auth.getResourceAuth(this.resource);
        // can only crud user documents
        const read = scope.includes("jobs.documents.user.read");
        const upload = scope.includes("jobs.documents.user.create") &&
            scope.includes("jobs.documents.user.update");
        const del = scope.includes("jobs.documents.user.delete");
        this.set("permissions", { read, write: upload, del });
    }
    closeDeleteConfirmation() {
        this.$["delete-confirmation"].close();
    }
    openDeleteConfirmation(e) {
        const { id } = e.target;
        this.set("deleteId", id);
        this.$["delete-confirmation"].open();
    }
    _uploadingChange() {
        if (this.uploading) {
            this.$.submitSpinner.active = true;
            this.$.dropZone.style.opacity = 0.2;
        }
        else {
            this.$.submitSpinner.active = false;
            this.$.dropZone.style.opacity = 1;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    _computeUploadMessage(status) {
        switch (status) {
            case "all_valid":
                return "Files ready fo upload";
            case "partial_valid": {
                const duplicateMsg = this.filesToUpload.find((f) => f.status === "duplicate")
                    ? "File(s) exists with the same name. "
                    : "";
                const exceedMaxSize = this.filesToUpload.find((f) => f.status === "toLarge")
                    ? "File(s) exceeding 100mb."
                    : "";
                return `${duplicateMsg}${exceedMaxSize}`;
            }
            case "all_uploaded":
                return "All files successfully uploaded";
            case "partial_uploaded":
                return "Issue uploading some documents";
            case "uploading":
                return "Uploading documents";
            case "no_files":
                return "No files to upload";
            default:
                return "";
        }
    }
    // eslint-disable-next-line class-methods-use-this
    _computeUploadStatus(files, uploading) {
        if (uploading)
            return "uploading";
        if (files.length === 0)
            return "no_files";
        if (files.every((f) => f.status === "ready"))
            return "all_valid";
        return "partial_valid";
    }
    // eslint-disable-next-line class-methods-use-this
    _computeDisabledUpload(status) {
        if (status === "all_valid") {
            return false;
        }
        return true;
    }
    // eslint-disable-next-line class-methods-use-this
    _computeUploadIcon(status) {
        switch (status) {
            case "all_valid":
                return "check-circle";
            case "partial_valid":
                return "warning";
            case "uploading":
                return "warning";
            case "all_uploaded":
                return "check-circle";
            case "partial_uploaded":
                return "error";
            case "none_created":
                return "error";
            case "no_files":
                return "warning";
            default:
                return "";
        }
    }
    // eslint-disable-next-line class-methods-use-this
    _computeUploadIconColour(status) {
        switch (status) {
            case "all_valid":
                return "#3BC2E6";
            case "partial_valid":
                return "#FB8C05";
            case "all_uploaded":
                return "#34A853";
            case "partial_uploaded":
                return "#EA4335";
            case "uploading":
                return "#3BC2E6";
            case "no_files":
                return "#8a8a8a";
            default:
                return "";
        }
    }
    dropHandler(ev) {
        ev.preventDefault();
        if (this.uploading)
            return;
        const { items } = ev.dataTransfer;
        const files = Object.values(items)
            .filter((f) => f.kind === "file")
            .map((f) => f.getAsFile());
        this.processFilesForUpload(files);
    }
    // eslint-disable-next-line class-methods-use-this
    dragOverHandler(ev) {
        ev.preventDefault();
    }
    addDocuments() {
        this.$.addFilesDialog.open();
    }
    changeFiles(e) {
        if (this.uploading)
            return;
        const { files } = e.target;
        this.processFilesForUpload(files);
    }
    processFilesForUpload(files) {
        const filesToUpload = Object.keys(files).map((key) => {
            const name = `${files[key].name}`;
            const size = Math.round((files[key].size / 1000000) * 100) / 100;
            return {
                name,
                lastModified: this.getLocalDateTime(files[key].lastModified),
                size,
                fileData: files[key],
                status: this._computeFileStatus(name, size),
            };
        });
        this.set("filesToUpload", filesToUpload);
    }
    _computeFileStatus(name, size) {
        if (size > 100) {
            return "toLarge";
        }
        return this.files.find((f) => f.title === name) ? "duplicate" : "ready";
    }
    _computeStatus(item) {
        if (this.uploading) {
            return "uploading";
        }
        return item.status;
    }
    close() {
        this.$.addFilesDialog.close();
        this.filesToUpload = [];
        this.uploading = false;
    }
    async uploadComplete() {
        console.debug(`${this.constructor.is}: Upload success`);
        await this.setDocuments();
        this.uploading = false;
        this.sendToastMessage("All files successfully uploaded");
        this.close();
    }
    uploadFailed() {
        this.uploading = false;
        this.sendToastMessage("There was an issues uploading, Please try again");
        this.setDocuments();
    }
    async upload() {
        this.uploading = true;
        try {
            // Only processing one file at a time to avoid issues with concurrency of read/write on job object
            // Can be increased when documents are separate entries
            await asyncPool(1, this.filesToUpload, this.uploadFile.bind(this));
            await this.uploadComplete();
        }
        catch (error) {
            this.uploadFailed();
        }
    }
    async uploadFile(file) {
        // Uploads files to blob store and updates entry in db
        const auth = await this.store.auth.getResourceAuth(`/jobs/${this.jobId}`);
        const oid = auth.subject;
        const now = Date.now();
        const [name] = file.name.split(".");
        const documentInfo = {
            id: `${now}_${name}`,
            title: file.name,
            size: file.size,
            url: `${now}/${file.name}`,
            type: "user",
            uploadedBy: { oid },
            deleted: false,
            uploadDate: now,
            uploaded: false, // updated in PATCH after uploaded
        };
        const { baseUrl, queryUrl: SAS } = await this.addDocumentToDB(documentInfo);
        await this.uploadFileToBlobStore(documentInfo.url, file.fileData, baseUrl, SAS);
        await this.markUploadComplete(documentInfo.id);
    }
    // eslint-disable-next-line class-methods-use-this
    async uploadFileToBlobStore(path, data, baseUrl, SAS) {
        console.debug(`${this.constructor.is}: Uploading ${path}`);
        const endpoint = `${baseUrl}${path}${SAS}`;
        return fetch(endpoint, {
            method: "PUT",
            mode: "cors",
            headers: {
                "x-ms-blob-type": "BlockBlob",
                "x-ms-version": "2019-12-12",
                "Content-length": data.size,
                "Content-Type": data.type,
            },
            body: data,
        });
    }
    sendToastMessage(message) {
        this.dispatchEvent(new CustomEvent("toastMessage", {
            bubbles: true,
            composed: true,
            detail: {
                message,
            },
        }));
    }
    async downloadDocument(e) {
        const { id } = e.target;
        // id is the title of the document
        const { url, title } = this.files.find((f) => f.title === id);
        let documentUrl;
        if (url.slice(0, 5) === "https") {
            documentUrl = url;
        }
        else {
            const { baseUrl, queryUrl } = await this.getSignedContainerUrl(title);
            documentUrl = `${baseUrl}${url}${queryUrl}`;
        }
        const win = window.open(documentUrl, "_blank");
        if (win)
            win.focus();
        else
            alert("Please allow popups for this website");
    }
    async addDocumentToDB(document) {
        console.debug(`${this.constructor.is}: Adding ${document.title} to db`);
        this.url = `${this.apiBaseUrl}/api/v1/jobs/${this.jobId}/documents`;
        this.$.apiRequest.method = "POST";
        this.$.apiRequest.body = document;
        this.authorizationRequired = true;
        this.$.apiRequest.authorizationType = "resource";
        this.$.apiRequest.resource = this.resource;
        return this.$.apiRequest.generateApiRequest();
    }
    async markUploadComplete(id) {
        this.url = `${this.apiBaseUrl}/api/v1/jobs/${this.jobId}/documents/${id}`;
        this.$.apiRequest.method = "PATCH";
        this.$.apiRequest.body = { uploaded: true };
        this.authorizationRequired = true;
        this.$.apiRequest.authorizationType = "resource";
        this.$.apiRequest.resource = this.resource;
        return this.$.apiRequest.generateApiRequest();
    }
    deleteDocument() {
        console.debug(`${this.constructor.is}: Deleting document`, this.deleteId);
        this.url = `${this.apiBaseUrl}/api/v1/jobs/${this.jobId}/documents/${encodeURIComponent(this.deleteId)}`;
        this.$.apiRequest.method = "DELETE";
        this.$.apiRequest.body = null;
        this.authorizationRequired = true;
        this.$.apiRequest.authorizationType = "resource";
        this.$.apiRequest.resource = this.resource;
        this.$.apiRequest.generateApiRequest().then(async () => {
            await this.setDocuments(); // Update Documents table
            this.closeDeleteConfirmation();
            this.sendToastMessage("Successfully deleted");
        });
    }
    getSignedContainerUrl(documentTitle) {
        this.url = `${this.apiBaseUrl}/api/v1/jobs/${this.jobId}/documents/download?document=${encodeURIComponent(documentTitle)}`;
        this.$.apiRequest.method = "GET";
        this.authorizationRequired = true;
        this.$.apiRequest.body = null;
        this.$.apiRequest.authorizationType = "resource";
        this.$.apiRequest.resource = this.resource;
        return this.$.apiRequest.generateApiRequest();
    }
    async setDocuments() {
        this.url = `${this.apiBaseUrl}/api/v1/jobs/${this.jobId}/documents`;
        this.$.apiRequest.method = "GET";
        this.authorizationRequired = true;
        this.$.apiRequest.body = null;
        this.$.apiRequest.authorizationType = "resource";
        this.$.apiRequest.resource = this.resource;
        const newDocuments = await this.$.apiRequest.generateApiRequest();
        console.log("Documents", newDocuments);
        this.set("files", newDocuments);
    }
    canDelete(type) {
        return type === "user" && this.permissions.del;
    }
}
customElements.define(SiteDocumentManagement.is, SiteDocumentManagement);
//# sourceMappingURL=site-document-management.js.map